import React, { lazy, Suspense } from 'react';
import { Router, Route, Redirect, Switch } from 'react-router-dom';
import sa from 'sa';
import history from 'histories';
import routers from './routers';
import ChunkLoading from 'components/chunk-loading';
import utils from 'utils';
import { store } from 'src/redux/store';
import Actions from 'actions';

const Routers = routers.map(route => {
  const Component = lazy(() => import(`../pages/${route.page}`));
  return (
    <Route
      exact
      path={route.path}
      key={route.path}
      component={props => <Component {...props} />}
    />
  );
});

class App extends React.Component {
  constructor() {
    super();
  }

  componentWillMount() {
    sa.quick('autoTrack');
  }

  componentDidMount() {
    const token = utils.getQueryString('token');
    if (token) {
      store.dispatch(Actions.updateToken(token));
    }
  }

  componentDidCatch(error) {
    if (window.$BooheeSender) {
      window.$BooheeSender.reportError(error);
    }
  }

  render() {
    return (
      <Router history={history}>
        <Suspense fallback={<ChunkLoading />}>
          <Switch>
            {Routers}
            <Redirect from="/" to="/" />
          </Switch>
        </Suspense>
      </Router>
    );
  }
}

export default App;
